<template>
  <div class="bg">
    <div class="company-basic">
      <div>
        <div class="company-title">
          {{ details.companyName }}
          <span v-if="details.threeActive == true" class="idcard-identity"
            >已认证</span
          >
          <span v-else class="idcard-unidentity">未认证</span>
        </div>
        <div class="company-pass">营业执照号：{{ details.companyCode }}</div>
      </div>
      <div class="company-detail"></div>
    </div>
    <div class="company-legal-person">
      <div class="company-legal-title">法人信息</div>
      <div class="company-legal-name">法人姓名： {{ details.legalPerson }}</div>
      <div class="company-legal-contact">
        联系方式：{{ details.legalPersonPhone }}
      </div>
    </div>
    <!--    <div v-if="details.authorizationStatus == 1" class="buttonUnidentity">-->
    <!--      公司电子签章认证已认证-->
    <!--    </div>-->
    <!--    <div v-else class="buttonUnidentity" @click="showBox1 = true">-->
    <!--      公司电子签章认证未认证-->
    <!--    </div>-->

    <div class="button-bottom" @click="goNext">
      编辑
    </div>

    <x-dialog v-model="showBox1">
      <div class="titleBox">
        <div class="title">认证方式</div>
        <div class="closeBox" @click="showBox1 = false">
          <span class="vux-close"></span>
        </div>
      </div>
      <div class="rzButton" @click="faren">法人认证</div>
      <div class="rzButton" @click="jinbanren">授权经办人</div>
      <div class="tip">
        *授权经办人认证后，经办人在业务中的任何行为将直接代表公司
      </div>
    </x-dialog>

    <x-dialog v-model="showBox2">
      <div class="popWrapper">
        <div class="titleBox">
          <div class="title">二维码</div>
          <div class="closeBox" @click="showBox2 = false">
            <span class="vux-close"></span>
          </div>
        </div>
        <div class="qrCode" id="qrCode" ref="qrCode"></div>
        <div class="tip">
          *请扫描二维码前去认证
        </div>
      </div>
    </x-dialog>
  </div>
</template>

<script>
import { getCompanyDetail } from "../../api/identify";
import { getUrl } from "../../api/company";
import QRCode from "qrcodejs2";

export default {
  name: "identifyCompanyDetail",
  data() {
    return {
      showBox1: false,
      showBox2: false,
      companyList: [],
      qrCodeUrl: "",
      details: "",
      companyId: ""
    };
  },
  created() {
    this.companyId = this.$route.params.id;
    this.getCompanyInfo();
  },
  methods: {
    goNext() {
      this.$router.push({ path: "/identify/companyEdit/" + this.companyId });
    },
    faren() {
      this.$vux.loading.show();
      this.closeCode();
      getUrl({ companyId: this.details.id, type: 1 })
        .then(res => {
          this.$vux.loading.hide();
          this.showBox1 = false;
          this.qrCodeUrl = res.url;
          this.make();
          this.showBox2 = true;
        })
        .catch(err => {
          this.$vux.loading.hide();
          this.$showError(err);
        });
    },
    jinbanren() {
      this.$vux.loading.show();
      this.closeCode();
      getUrl({ companyId: this.details.id, type: 2 })
        .then(res => {
          this.$vux.loading.hide();
          this.showBox1 = false;
          this.qrCodeUrl = res.url;
          this.make();
          this.showBox2 = true;
        })
        .catch(err => {
          this.$vux.loading.hide();
          this.$showError(err);
        });
    },
    make() {
      let that = this;
      new QRCode("qrCode", {
        width: 200,
        height: 200,
        text: that.qrCodeUrl // 二维码地址
      });
    },
    closeCode() {
      this.$refs.qrCode.innerHTML = "";
    },
    getCompanyInfo() {
      getCompanyDetail({ companyId: this.companyId })
        .then(res => {
          if (res) {
            this.details = res;
          }
        })
        .catch(err => {
          this.$showError(err);
        });
    }
  }
};
</script>

<style lang="less" scoped>
.bg {
  overflow: hidden;
  font-size: 14px;
}
.button-bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 100px;
  line-height: 100px;
  font-size: 16px;
  text-align: center;
}
.button-default {
  background: #1573ff;
  color: #fff;
}
.buttonUnidentity {
  width: 80%;
  height: 80px;
  line-height: 80px;
  text-align: center;
  background: #2b80fe;
  color: #fff;
  font-size: 14px;
  margin: 40px auto;
}
.company {
  &-basic {
    padding: 90px 30px 30px;
    background: #ffffff;
  }
  &-title {
    color: #262626;
    font-size: 19px;
  }
  &-pass {
    font-size: 13px;
    color: #474747;
  }
  &-address {
    font-size: 15px;
    color: #474747;
    height: 70px;
  }
  &-mobile {
    font-size: 15px;
    color: #474747;
    display: flex;
    height: 70px;
    justify-content: space-between;
  }
  &-detail {
    margin-top: 70px;
    .icon {
      margin-right: 30px;
    }
  }
  &-legal-person {
    background: #ffffff;
    font-size: 15px;
    color: #474747;
    margin-top: 20px;
    padding: 30px;
  }
  &-legal-title {
    margin-bottom: 30px;
  }
  &-legal-name {
    margin-bottom: 10px;
  }
}

.idcard-identity {
  color: #4695fb;
  font-size: 10px;
  background: rgba(220, 235, 254, 1);
  border: 1px solid rgba(158, 197, 253, 1);
  border-radius: 15px;
  padding: 0 5px;
  margin-left: 6px;
}

.idcard-unidentity {
  color: #eb8f8f;
  background: #feeeee;
  border: 1px solid #eb8f8f;
  font-size: 10px;
  border-radius: 15px;
  padding: 0 5px;
  margin-left: 6px;
}
.titleBox {
  padding: 15px;
  overflow: hidden;
}
.title {
  font-size: 16px;
  float: left;
}
.closeBox {
  float: right;
  display: block;
  overflow: hidden;
}
.rzButton {
  width: 400px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  background: #1890ff;
  color: #fff;
  margin: 50px auto;
  font-size: 14px;
  border-radius: 10px;
}
.tip {
  color: red;
  padding: 30px;
  text-align: center;
  font-size: 14px;
}
.popWrapper {
  background: #fff;
  border-radius: 8px;
  width: 600px;
  overflow: hidden;
}

.title1 {
  width: 100%;
  height: 100px;
  line-height: 100px;
  font-size: 16px;
  text-align: center;
  color: #262626;
}

.qrCode {
  width: 400px;
  height: 400px;
  margin: 0 auto;
}
</style>
